export const UploadIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#9a958f"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="mx-auto"
  >
    <path d="M12 16V4" />
    <path d="M7 9l5-5 5 5" />
    <path d="M4 20h16" />
  </svg>
);
